/*
 * Copyright (c) 2025-2026 Terra Technology (Guangzhou) Co., Ltd.
 * Copyright (c) 2024-2026 山东艾坦迪数智科技有限公司.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

export * from './http';

export enum OperationEnum {
  CREATE = 'create',
  EDIT = 'edit',
  DETAIL = 'detail',
  AUTHORIZE = 'authorize',
  ALLOCATABLE = 'allocatable',
  REFRESH = "refresh",       // 添加REFRESH，表示页面需要刷新，用在修改或新增记录后，列表页需要刷新
  CONFIG = "config"
}

export enum Permissions {
  permissionCreate = 'security:permission:create',
  permissionEdit = 'security:permission:edit',
  permissionDelete = 'security:permission:delete',
  superAdmin = 'super:super-admin'
}

export enum DictKeyEnum {
  GENDER = 'gender',
  CAMPUS_TYPE = "campusType",
}

export enum DataItemStatus {
  ENABLE,
  FORBIDDEN,
  DISABLE = 1,
  LOCKING,
  EXPIRED
}

export enum EnergyCategory {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  STEAM = 'STEAM',
  WATER = 'WATER',
  OTHER = 'OTHER',
}

export const EnergyCategoryLabel: Record<EnergyCategory, string> = {
  [EnergyCategory.ELECTRIC]: '电力',
  [EnergyCategory.GAS]: '燃气',
  [EnergyCategory.STEAM]: '蒸汽',
  [EnergyCategory.WATER]: '水',
  [EnergyCategory.OTHER]: '其他',
};
